import types from "../types";

export const fetchNonAuthActivity = (data) => ({
  type: types.nonAuthWatchTime.FETCH_NON_AUTH_ACTIVITY,
  payload: data,
});
